const Request = require('./BaseRequest')
const WebsiteGraph = require('../graph/WebsiteGraph')
const { formatSiteUrls } = require('../general')

module.exports = class WebsiteRequest extends Request
{
    constructor(apiDomain)
    {
        super(apiDomain)
        this.graph = new WebsiteGraph(this.apiDomain)
    }

    async siteData(url)
    {
        let args = {url: url}
        let { type, query } = this.graph.webpageQuery([
            { site: [
                'id', 'websiteId', 'accountId', 'name', 'brand', 'url', 'subdomainUrl', 'domainUrl',
                {site: ['id', 'code', 'name']}
            ]}
        ])
        let data = await this.graph.request(query, args, type)
        return data
    }

    async pageData(url)
    {
        let args = {url: url}
        let { type, query } = this.graph.webpageQuery([
            { page: [
                {page: ['id', 'label', 'href']},
                'title', 'description', 'rawTitle', 'rawDescription', 'defaultTitle', 'defaultDescription'
            ]}
        ])
        let data = await this.graph.request(query, args, type)
        return data
    }

    async siteUrls(accountId, codes)
    {
        let args = { accountId: accountId, codes: codes }
        let { type, query } = this.graph.sitesQuery([
            {site: ['name', 'code']},
            'subdomainUrl', 'domainUrl'
        ])
        var data = await this.graph.request(query, args, type)
        if (typeof data.err === "undefined")
            data = formatSiteUrls(data)
        else
            return {}
        return data
    }

    async saveCustomization(websiteId, optional={}, allData=false)
    {
        let args = { websiteId: websiteId, ...optional }
        let { type, query } = this.graph.saveCustomizationMutation(['custom'])
        let data = await this.graph.request(query, args, type, allData)
        return data
    }

    async reset(websiteId)
    {
        let args = { websiteId: websiteId }
        let { type, query } = this.graph.resetMutation(['custom'])
        let data = await this.graph.request(query, args, type)
        return data
    }

    async resetPage(websiteId, page_id)
    {
        let args = { websiteId: websiteId, page_id: page_id }
        let { type, query } = this.graph.resetPageMutation(['custom'])
        let data = await this.graph.request(query, args, type)
        return data
    }

    async customLink(websiteId, label, link)
    {
        let args = { websiteId: websiteId, label: label, link: link }
        let { type, query } = this.graph.customLinkMutation(['id', 'label', 'identifier', 'route_url', 'isClient'])
        let data = await this.graph.request(query, args, type)
        return data
    }

    async removeFile(websiteId, block, item)
    {
        let args = { websiteId: websiteId, block: block, item: item }
        let { type, query } = this.graph.removeFileMutation(['websiteId', 'result', 'block', 'item'])
        let data = await this.graph.request(query, args, type, true)
        return data
    }

    async pageContent(url)
    {
        let args = { url: url }
        let { type, query } = this.graph.pageContentQuery([
            {sections: ['id', 'identifier']},
            'content',
            'hero',
            'sharing_img',
            {banner: ['id', 'name', 'style', 'srcImg','isCustom']}
        ])
        let data = await this.graph.request(query, args, type, true)
        return data
    }


    swrPageLayout(url)
    {
        let args = { url: url }
        let { type, query } = this.graph.pageLayoutQuery([
            {style: ['id', 'name', 'favicon', 'style']},
            {theme: ['id', 'name', 'favicon', 'style']},
            {navigation: ['id', 'label', 'href', 'isClient']},
            {footer_navigation: ['label', 'href']},
            {header: ['identifier']},
            {footer: ['identifier']},
            'append_end',
            'blog_layout'
        ], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrPageContent(url)
    {
        let args = { url: url }
        let { type, query } = this.graph.pageContentQuery([
            {sections: ['id', 'identifier']},
            'content',
            'hero',
            'sharing_img',
            {banner: ['id', 'name', 'style', 'srcImg','isCustom']}
        ], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrNavigation(url)
    {
        let args = { url: url }
        let { type, query } = this.graph.pageLayoutQuery([
            {navigation: ['id', 'label', 'href', 'isClient']},
            {footer_navigation: ['id', 'label', 'href']},
        ], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrSites(accountId)
    {
        let args = { accountId: accountId }
        let { type, query } = this.graph.sitesQuery([
            'id', 'url','subdomainUrl','domainUrl',
            {site: ['name', 'code','route']}
        ], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrSite(accountId, code)
    {
        let args = { accountId: accountId, code: code }
        let { type, query } = this.graph.siteQuery([
            'id', 'url', 'subdomainUrl', 'domainUrl', 'config',
            {site: ['name', 'code']}
        ], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrBanners(optional={})
    {
        let args = { ...optional }
        let { type, query } = this.graph.bannersQuery(['id', 'name', 'style', 'srcImg', 'thumbnailImg','isCustom'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrStyles(optional={})
    {
        let args = { ...optional }
        let { type, query } = this.graph.stylesQuery(['id', 'name', 'style', 'thumbnailImg'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrNavigationList(websiteId)
    {
        let args = { websiteId: websiteId }
        let { type, query } = this.graph.navigationQuery(['id', 'label', 'identifier', 'route_url', 'isClient'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrSections(websiteId, page_id)
    {
        let args = { websiteId: websiteId, page_id: page_id }
        let { type, query } = this.graph.sectionsQuery(['id', 'label', 'identifier', 'content', 'thumbnailImg'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }
}